import React, { forwardRef } from 'react';
import classnames from 'classnames';
import s from './StickyContent.scss';
var StickyContent = forwardRef(function (_a, innerRef) {
    var isStuck = _a.isStuck, className = _a.className, style = _a.style, children = _a.children;
    return (React.createElement("div", { className: classnames(s['content'], isStuck && s['stuck'], isStuck && className), style: isStuck ? style : undefined, ref: innerRef }, children(isStuck)));
});
StickyContent.displayName = 'StickyContent';
export default React.memo(StickyContent);
//# sourceMappingURL=StickyContent.js.map